import { useEffect } from 'react';
import { initDD, isConsentRequired, isDDInitialized } from '#utils/dd';

const TRACKING_CONSENT_KEY = 'C0002';

/**
 * Starts Datadog RUM once per page load.
 * - Prod shows the OneTrust cookie banner: RUM starts only after the user accepts
 *   performance cookies (C0002). If they withdraw that consent later, the page
 *   reloads, because a running RUM session can't be stopped.
 * - Dev and stage have no banner: RUM starts right away.
 */
const useDatadogRum = () => {
  useEffect(() => {
    if (!isConsentRequired()) {
      if (!isDDInitialized()) initDD();
      return undefined;
    }

    const checkConsentAndInit = () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const optanonActiveGroups = (window as any).OptanonActiveGroups;
      if (
        optanonActiveGroups &&
        optanonActiveGroups.includes(TRACKING_CONSENT_KEY) &&
        !isDDInitialized()
      ) {
        initDD();
      }
      if (
        optanonActiveGroups &&
        !optanonActiveGroups.includes(TRACKING_CONSENT_KEY) &&
        isDDInitialized()
      ) {
        // Since dd does not have a way to stop tracking, we reload the page
        window.location.reload();
      }
    };
    // Check OT active groups
    const waitForOneTrust = () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const optanonActiveGroups = (window as any).OptanonActiveGroups;
      if (optanonActiveGroups) {
        checkConsentAndInit();
      } else {
        setTimeout(waitForOneTrust, 100);
      }
    };
    waitForOneTrust();

    window.addEventListener('OneTrustGroupsUpdated', checkConsentAndInit);

    // Cleanup listener on unmount
    return () => {
      window.removeEventListener('OneTrustGroupsUpdated', checkConsentAndInit);
    };
  }, []);
};

export default useDatadogRum;
